import { RewardsProgramDialog } from '@colonist/clientforge';
import { ReferralTypeEnum } from '../../../../shared/entity_datas/EntityDatas.ts';
import { ReferralProgram } from '../../../../shared/ReferralProgram.ts';
import { SDKRequest } from '../../../../shared/DiscordActivityTypes.ts';
import { mountDialogUIReactComponent } from '../../../shared/scripts/ui_platform/mountDialogUIReactComponent.tsx';
import { getLobbyImagePath } from '../../../shared/scripts/ui_utils/Utils.ts';
import { navigateToPage } from '../../../shared/scripts/ui_utils/ClientUtils.ts';
import { clientI18n } from '../../../shared/scripts/ClientI18n.ts';
import { DiscordInstance } from '../discord/DiscordInstance.ts';
const renderRewardsProgramDialog = mountDialogUIReactComponent(RewardsProgramDialog);
export function showDiscordShareActivityLinkPopup(analyticsPopupTriggered, analyticsSuccessfullyShared) {
    DiscordInstance.getDiscordInstance().sendSDKRequest(SDKRequest.ShareActivityLink, {
        message: clientI18n.t('strings:homePage.popups.discordShareActivity.text'),
        referralTypeId: ReferralTypeEnum.DiscordShareActivityReturnToHomeAfterGameEndPopup.toString(),
        analyticsPopupTriggered: analyticsPopupTriggered,
        analyticsPopupSuccess: analyticsSuccessfullyShared
    });
}
export function showRewardsProgramDialog(analyticsPopupTriggered, analyticsSuccessfullyShared) {
    const rewards = ReferralProgram.referralRewardLevels.map((referralReward)=>({
            image: {
                src: getLobbyImagePath(referralReward.image),
                alt: referralReward.name
            },
            name: referralReward.name,
            referralCount: referralReward.referralCount
        }));
    renderRewardsProgramDialog({
        rewards: rewards,
        onConfirm: ()=>{
            showDiscordShareActivityLinkPopup(analyticsPopupTriggered, analyticsSuccessfullyShared);
            navigateToPage('/store#referrals');
        }
    });
}
